<div class="container" *ngIf="initialized">
  <router-outlet></router-outlet>
</div>
<app-loader></app-loader>
